import { useEffect, useRef, useState } from "react";
import { Avatar } from "@mui/material";
import ProfilePop from "./ProfilePop";
import { picBaseUrl } from "../../config/config";
import { useLocation } from "react-router-dom";
import { useUserData } from "../../Hooks/App_Context";
import { Notifications } from "../../components/Notifications/Notifications";
import { Get_User_Details } from "../../DAL/Login/Auth";
// ----------------------------------------------------------------------

export default function AccountPopover({ setIsLoading }) {
  const anchorRef = useRef(null);
  const { userData = {}, setUserData, setUnreadMessageCount } = useUserData();
  const [open, setOpen] = useState(false);
  const [ProfileInfo, setProfileInfo] = useState({});

  const { pathname } = useLocation();
  useEffect(() => {
    setTimeout(() => {
      // Delay cleanup to allow route change to settle and remove any search or filter set in that component when user navigate away
      const is_path_includes = (path) => {
        return pathname.toString().includes(path);
      };
      if (!is_path_includes("/user-management")) {
        localStorage.removeItem("searchText_User_Managements");
      }
      if (!is_path_includes("/employee-management")) {
        localStorage.removeItem("searchText_Employee_Managements");
      }
      if (!is_path_includes("/business-center")) {
        localStorage.removeItem("searchText_Business_Center");
      }
      if (!is_path_includes("/agency-accounts")) {
        localStorage.removeItem("filterData_Agency_Account");
        localStorage.removeItem("searchText_Agency_Account");
      }
      if (!is_path_includes("/support-ticket")) {
        localStorage.removeItem("support_tickets_data");
      }
      if (!is_path_includes("/transactions-list")) {
        localStorage.removeItem("FilterData_Subscription_Payments_List");
        localStorage.removeItem("All_Deposit_List_Search_Text");
      }
      if (!is_path_includes("/wallet-transactions")) {
        localStorage.removeItem("Filter_Data_Wallet_Transaction");
        localStorage.removeItem("Wallet_Transaction_Search_Text");
      }
      if (!is_path_includes("/transactions-list")) {
        localStorage.removeItem(
          "Subscriptions_Trasactions_Trasactions_List_Filter"
        );
      }
      if (!is_path_includes("/cc-authorization")) {
        localStorage.removeItem("searchText_CC_Authorization_Page");
      }
      if (!is_path_includes("/clear-wallet-balance")) {
        localStorage.removeItem("clear_wallet_transaction_page");
      }
    }, 1000);
  }, [pathname]);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // Getting details of the user this is the api function used to set details of the admin in the context
  const getUserData = async () => {
    const response = await Get_User_Details();
    if (response.code === 200) {
      setUserData(response.admin);
      setUnreadMessageCount(response.total_unread_meassage_count);
      localStorage.setItem("UserData", JSON.stringify(response.admin));
    }
  };

  // Calling that Function of fetching user details on component mount
  useEffect(() => {
    getUserData();
  }, []);

  // Setting the profile info of the user
  useEffect(() => {
    if (userData) {
      setProfileInfo({
        name: `${userData?.first_name} ${userData?.last_name}`,
        avatar: userData?.profile_image,
        email: userData?.user_id?.email,
        _id: userData?.user_id?._id,
      });
    }
  }, [userData]);

  return (
    <div className={`mt-4 px-0`}>
      <div className="d-flex justify-content-between profile_menu">
        <div className="left-item">
          <Notifications ProfileInfo={{ ProfileInfo }} />
        </div>
        <div className="right-item ms-3">
          <div
            className="profile-container"
            ref={anchorRef}
            onClick={handleOpen}
          >
            <div className="profile-avatar">
              <Avatar
                variant="rounded"
                sx={{ width: 40, height: 40 }}
                src={
                  ProfileInfo?.avatar
                    ? picBaseUrl + ProfileInfo?.avatar
                    : ProfileInfo?.avatar === "undefined"
                    ? "https://placehold.co/600x400?text=Hello+World"
                    : "https://placehold.co/600x400?text=Hello+World"
                }
              />
            </div>
            <div className="profile-info d-none d-md-flex">
              <span className="user-name">{ProfileInfo?.name}</span>
            </div>

            <span className="chevron-icon pointer ms-0">
              <i
                className={`ms-3 me-2 fa-solid ${
                  open ? "fa-chevron-up" : "fa-chevron-down"
                } `}
              ></i>
            </span>
          </div>
        </div>
      </div>
      {
        <ProfilePop
          name={ProfileInfo?.name}
          email={ProfileInfo?.email}
          open={open}
          handleClose={handleClose}
          anchorEl={anchorRef.current}
        />
      }
    </div>
  );
}
